

export interface SidebarState {
  isCollapsed: boolean;
}

// Base classes - dynamic width based on collapsed state
export const getSidebarBaseClasses = (isCollapsed: boolean) => 
  `flex flex-col h-full bg-white border-r border-gray-200 ${
    isCollapsed ? 'w-16' : 'w-64'
  } rounded-bl-lg transition-all duration-300 ease-in-out ${
    isCollapsed ? 'px-2' : 'px-4'
  } max-[1200px]:w-16 max-[1200px]:px-2`;


// Logo classes - adapt to collapsed state
export const getSidebarLogoClasses = (isCollapsed: boolean) => 
  `flex items-center py-5 justify-center ${isCollapsed ? 'justify-center' : ''}`;

// Animation classes
export const sidebarAnimationClasses = {
  transition: "transition-all duration-300 ease-in-out",
  textFade: "transition-opacity duration-200",
  tooltipShow: "opacity-100 pointer-events-auto",
  tooltipHide: "opacity-0 pointer-events-none",
};

// Deprecated - keeping for backward compatibility but will be removed
export const baseClasses = "flex flex-col h-full bg-white border-r border-gray-200 w-64 rounded-bl-lg px-4";
export const itemClasses = {
  base: "flex items-center py-2 px-3 text-gray-700 hover:bg-[#FAFAFA] transition-colors text-base font-semibold rounded-lg",
  active: "bg-[#FAFAFA] text-[#252B37]",
  icon: "w-5 h-5 mr-3 text-gray-500",
  activeIcon: "text-[#252B37]",
  label: "text-base font-semibold",
};
export const logoClasses = "flex items-center py-5";

